/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect } from 'react';
import { useSpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/page-ready-state/index.tsx';
import { useSpaStateTransition } from '@atlassian/jira-spa-state-controller/src/components/transition-state/index.tsx';
/**
 * Ensures the web application's interactive state is accurately tracked and managed across single-page application (SPA) transitions.
 * This involves marking the page as interactive when ready and resetting performance stats after each SPA transition to maintain accurate performance monitoring.
 */
export const useWrmStatsEffects = (): void => {
	const isReady = useSpaStatePageReady();
	const [{ transitionsCount }] = useSpaStateTransition();
	useEffect(() => {
		if (
			isReady &&
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.__WRM_INTERNAL_STATS__ &&
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			!window.__WRM_INTERNAL_STATS__.isPageInteractive
		) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
		}
	}, [isReady]);
	useEffect(() => {
		if (transitionsCount > 0) {
			// clear stats on transition

			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.__WRM_INTERNAL_STATS__ = {};
		}
	}, [transitionsCount]);
};
